<template>
  <v-card class="elevation-12">
    <v-toolbar
      dark
      color="primary"
    >
      <v-toolbar-title class="text-no-wrap">Team Registration</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
        <div class="headline">{{this.gameDetails.gameName}}</div>
        <div class="ma-3">{{this.gameDetails.gameOccurrenceDescription}}</div>
        <div class="font-weight-regular font-italic">Scheduled on: {{this.gameDetails.scheduledDate | moment("MM-DD-YY")}}</div>
        <v-divider class="mt-2 mb-4"></v-divider>
        <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                prepend-icon="group"
                name="teamName"
                v-model="teamName"
                label="Create a Team Name"
                required
                :rules="teamNameRules"
              ></v-text-field>
              <v-slider
              v-model="teamSize"
              :rules="teamSizeRules"
              color="accent"
              label="How many are on your team?"
              hint="A team size is at least 1, guess if you're not sure"
              min="1"
              max="10"
              thumb-label
              thumb-size="48"
            ></v-slider>
            </v-form>
        <span
          class="error--text"
          v-show="apiMessage"
        >{{apiMessage}}</span>
    </v-card-text>
    <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              @click="joinGame"
            >Join Game!</v-btn>
          </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import GameModel from "../../api/game-model";

export default {
  name: "TeamRegistration",
  data() {
    return {
      valid:false,
      teamName: "",
      teamSize: 1,
      teamNameRules: [v => !!v || "A team name is required"],
      teamSizeRules: [v => !!v || "A team size is at least 1, guess if you're not sure"]
    };
  },
  computed: {
    ...mapState("client", {
      gameDetails: state => state.game.gameDetails,
      apiMessage: state => state.apiMessage
    })
  },
  methods: {
    joinGame() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("client/joinGame", {
            teamName: this.teamName,
            teamSize: this.teamSize
          })
          .catch(e => alert("Bummer, we failed to register your team... " + e.message));
      }
    }
  }
};
</script>